import { IConstraintPopSlidesAllowableDay } from '../../interfaces/iconstraint-pop-slides-allowable-day';
import { Area } from '../area';
import { Scenario } from '../scenario';

export class ConstraintPopSlidesAllowableDayBase {
  ConstraintPopSlidesAllowableDayId: number;
  ScenarioId: number;
  AreaId: number | null;
  DaySlideDays: number | null;
  PopSlideDays: number | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  Scenario?: Scenario;

  constructor(item?: IConstraintPopSlidesAllowableDay) {
    if (item) {

      this.ConstraintPopSlidesAllowableDayId = item.ConstraintPopSlidesAllowableDayId;
      this.ScenarioId = item.ScenarioId;
      this.AreaId = item.AreaId;
      this.DaySlideDays = item.DaySlideDays;
      this.PopSlideDays = item.PopSlideDays;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}